import React, { useCallback } from "react";
import { useAddAppointmentNote } from '@widgets/appointment/api/useAddAppointmentNote';
import { MaterialComposer } from "@widgets/appointment/ui/material-composer/material-composer";

export const AddNoteCard = ({appointmentId, startExpanded = false}) => {
	const {mutateAsync: createNote} = useAddAppointmentNote(appointmentId)

	const handleSubmit = useCallback(
		({ text, attachments, existingFileIds }) =>
		createNote({appointmentId, 
			data: {
				text: text || null
			},
			attachments,
			filesId: existingFileIds
		}),
		[appointmentId, createNote]
	)

  return (
    <MaterialComposer
			addButtonLabel="Добавить материал"
			startExpanded={startExpanded}
			onSubmit={handleSubmit}
		/>
  );
};
